const autoRegisterUrl = "v1/credit/profiles/account-associations/sync";
export {
  autoRegisterUrl
};
//# sourceMappingURL=endpoints.js.map
